export default {
  /**
   * Strip the provided html string of all tags.
   * @param html
   * @returns {string}
   */
  stripHtml (html) {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.body.textContent
  }
}
